// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useId, useRef } from 'react';
import { routerPush } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GlobalActionsLabels,
  GLOBAL_ACTIONS_LABELS,
  lblStyliticsCarouselCta,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import Carousel from '@tcp/core/src/components/common/atoms/Carousel';
import ImageRedirect from '@tcp/core/src/components/common/atoms/PressAbleCard';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { Item, CardImage, CtaText } from '../styles/RedirectCarousel.style';

export const goToOutFit = ({ id, subItemsId }) => {
  const outfitUrl = `/outfit?outfitId=${id}&vendorColorProductIdsList=${subItemsId}&viaModule=Stylitics_Outfit_Carousel&viaPage=plp`;
  const outfitPath = `/outfit/${id}/${subItemsId}`;
  routerPush(outfitUrl, outfitPath);
};

const renderItem = (item, isLastImage, ctaText, itemRef) => {
  return (
    <Item ref={itemRef} isLastImage={isLastImage} className="sc-item">
      <ImageRedirect
        onPress={() => goToOutFit(item)}
        additionalClassName="stylitics-top-promo-item"
      >
        <CardImage src={item.largeImageUrl} className={'stylitics-item-image'} />
        {ctaText ? (
          <CtaText>
            {ctaText.toUpperCase()}
            {' > '}
          </CtaText>
        ) : null}
      </ImageRedirect>
    </Item>
  );
};

const RedirectCarousel = ({ carouselContent, itemGap }) => {
  const uniqueId = useId();
  const itemRefs = useRef([]);
  const carouselRef = useRef(null);
  const ctaText = renderLabel(
    getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACTIONS_LABELS}.${lblStyliticsCarouselCta}`,
      GlobalActionsLabels
    ),
    lblStyliticsCarouselCta
  );
  return (
    <Carousel
      key={uniqueId}
      ref={carouselRef}
      overrideGap={itemGap}
      className="stylitics-carousel-wrapper"
    >
      {carouselContent.map((itemContent, index) => {
        itemRefs.current[index] = itemRefs.current[index] || React.createRef();
        const isLastImage = index === carouselContent.length - 1;
        return renderItem(itemContent, isLastImage, ctaText, itemRefs.current[index]);
      })}
    </Carousel>
  );
};

RedirectCarousel.propTypes = {
  carouselContent: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      subItemsId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      largeImageUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
  itemGap: PropTypes.number.isRequired,
};

export default errorBoundary(RedirectCarousel);
